"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    cet: 'המרכז לטכנולוגיה חינוכית',
    copy_rights: 'כל הזכויות שמורות',
    term_of_use_link: 'https://storage.cet.ac.il/support/TermsOfUseAndPrivacy.pdf',
    term_of_use: 'תנאי שימוש ופרטיות',
    system_requirements_link: 'https://storage.cet.ac.il/support/SystemRequirements.pdf',
    system_requirements: 'דרישות מערכת',
    accessability_terms_link: 'https://lo.cet.ac.il/player/?document=68604a47-5583-4b2d-b4c2-9591007e9c8a&language=he&&options=nobar',
    accessability_terms: 'הסדרי נגישות',
    about_link: 'https://home.cet.ac.il/about-us/',
    about: 'אודות ',
    purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms',
    purchase: 'רכישת מינוי',
    help_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    help: 'תמיכה והדרכה',
    contact_us: 'צרו קשר',
    address_street: 'קלאוזנר 16, ת.ד. 39513',
    address_city: 'תל אביב-יפו 6901128',
    contact_email: 'sherut@cet.ac.il',
    contact_phone: '03-6460800',
    facebook_link: 'https://www.facebook.com/cet.ac.il/',
    facebook: ' הפייסבוק שלנו',
    linkedin_link: 'https://www.linkedin.com/company/the-center-for-educational-technology-cet-',
    linkedin: 'הלינקדאין שלנו',
    youtube_link: 'https://www.youtube.com/channel/UCl_NiHQwP-X1D0JXGIaLp_Q',
    youtube: 'היוטיוב שלנו'
  },
  ar: {
    cet: 'مركز التكنولوجيا التربويّة',
    copy_rights: 'جميع الحقوق محفوظة',
    term_of_use_link: 'https://storage.cet.ac.il/support/TermsOfUseAndPrivacy_AR.pdf',
    term_of_use: 'شروط الاستخدام والخصوصيّة',
    system_requirements_link: 'https://storage.cet.ac.il/support/SystemRequirements_AR.pdf',
    system_requirements: 'متطلّبات المنظومة',
    accessability_terms_link: 'https://lo.cet.ac.il/player/?document=68604a47-5583-4b2d-b4c2-9591007e9c8a&language=ar&options=nobar',
    accessability_terms: 'ترتيبات تسهيل الوصول',
    about_link: 'https://home.cet.ac.il/about-us/?lang=ar',
    about: 'حول الموقع',
    purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms-ar',
    purchase: 'شراء اشتراك',
    help_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    help: 'دعم ومساعدة',
    contact_us: 'اتّصل بنا',
    address_street: 'كلاوزنر 16 ص.ب. 39513',
    address_city: 'تل-أبيب يافا 6901128',
    contact_email: 'sherut@cet.ac.il',
    contact_phone: '03-6460800',
    facebook_link: 'https://www.facebook.com/cet.ac.il/',
    facebook: ' صفحتنا على الفيسبوك',
    linkedin_link: 'https://www.linkedin.com/company/the-center-for-educational-technology-cet-',
    linkedin: 'صفحتنا على لينكد إن',
    youtube_link: 'https://www.youtube.com/channel/UCl_NiHQwP-X1D0JXGIaLp_Q',
    youtube: 'اليوتيوب الخاصّ بنا'
  },
  en: {
    cet: 'המרכז לטכנולוגיה חינוכית',
    copy_rights: 'כל הזכויות שמורות',
    term_of_use_link: 'https://storage.cet.ac.il/support/TermsOfUseAndPrivacy.pdf',
    term_of_use: 'תנאי שימוש ופרטיות',
    system_requirements_link: 'https://storage.cet.ac.il/support/SystemRequirements.pdf',
    system_requirements: 'דרישות מערכת',
    accessability_terms_link: 'https://lo.cet.ac.il/player/?document=68604a47-5583-4b2d-b4c2-9591007e9c8a&language=he&&options=nobar',
    accessability_terms: 'הסדרי נגישות',
    about_link: 'https://home.cet.ac.il/about-us/',
    about: 'אודות ',
    purchase_link: 'https://www.cet-catalogue.cet.ac.il/digital-forms',
    purchase: 'רכישת מינוי',
    help_link: 'https://lo.cet.ac.il/player/?document=8cc8973b-8a06-4410-8e2c-c241a6968a45&language=he&options=nobar',
    help: 'תמיכה והדרכה',
    contact_us: 'צרו קשר',
    address_street: 'קלאוזנר 16, ת.ד. 39513',
    address_city: 'תל אביב-יפו 6901128',
    contact_email: 'sherut@cet.ac.il',
    contact_phone: '03-6460800',
    facebook_link: 'https://www.facebook.com/cet.ac.il/',
    facebook: ' הפייסבוק שלנו',
    linkedin_link: 'https://www.linkedin.com/company/the-center-for-educational-technology-cet-',
    linkedin: 'הלינקדאין שלנו',
    youtube_link: 'https://www.youtube.com/channel/UCl_NiHQwP-X1D0JXGIaLp_Q',
    youtube: 'היוטיוב שלנו'
  }
};